/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TranscribeAudioResponseDto
 */
export interface TranscribeAudioResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TranscribeAudioResponseDto
     */
    text: string;
}

/**
 * Check if a given object implements the TranscribeAudioResponseDto interface.
 */
export function instanceOfTranscribeAudioResponseDto(value: object): value is TranscribeAudioResponseDto {
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function TranscribeAudioResponseDtoFromJSON(json: any): TranscribeAudioResponseDto {
    return TranscribeAudioResponseDtoFromJSONTyped(json, false);
}

export function TranscribeAudioResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TranscribeAudioResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
    };
}

export function TranscribeAudioResponseDtoToJSON(json: any): TranscribeAudioResponseDto {
    return TranscribeAudioResponseDtoToJSONTyped(json, false);
}

export function TranscribeAudioResponseDtoToJSONTyped(value?: TranscribeAudioResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
    };
}

